import createAsyncData from 'modules/core/hooks/createAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { Taxonomies } from 'modules/contracts/store/collections/taxonomies'

export interface CommonContractData {
  loading: boolean
  compensationTaxonomies: Taxonomies
}

const useFetchData = createAsyncData(
  (legalEntityId: number, compensationTaxonomies: Taxonomies) => {
    const data = {
      legal_entity_id: legalEntityId,
    }

    return Promise.all([
      compensationTaxonomies.fetch({
        data,
      }),
    ])
  }
)

const useFetchCommonContractData = (legalEntityId: number): CommonContractData => {
  const compensationTaxonomies = useLazyRef<Taxonomies>(() => new Taxonomies()).current
  const loading = useFetchData(legalEntityId, compensationTaxonomies)

  return {
    loading,
    compensationTaxonomies,
  }
}

export default useFetchCommonContractData
